import React, {FC} from 'react';
import {Spinner} from 'react-bootstrap';
import ArrowLeft from 'assets/icons/arrow-left.svg';
import ArrowRight from 'assets/icons/arrow-right.svg';
import {DateSlot} from 'components/TimePicker/types';
import {filterTimes} from 'hooks/useEvents/filter';

import Entry from './Entry';

import * as styles from './styles.module.scss';

interface DateListProps {
	dateSlots: DateSlot[],
	selected?: DateSlot,
	scroll: boolean,
	loading: boolean,
	onSelect: (i: number) => void,
}

const DateList: FC<DateListProps> = ({dateSlots, selected, scroll, loading, onSelect}) => {
	const defaultSkip = 3;
	const maxIndex = dateSlots.length - 1;

	// Implement click behavior for left arrow
	const leftProps = (() => {
		if (!selected || selected.index <= 0) {
			return {
				disabled: true,
			};
		}

		return {
			onClick: () => onSelect(
				Math.max(0, selected.index - defaultSkip),
			),
		};
	})();

	// Implement click behavior for right arrow
	const rightProps = (() => {
		if (!selected || selected.index >= maxIndex) {
			return {
				disabled: true,
			};
		}

		return {
			onClick: () => onSelect(
				Math.min(maxIndex, selected.index + defaultSkip),
			),
		};
	})();

	// Render our list of date entries
	return (
		<div className={styles.list}>
			<button className={styles.arrow} {...leftProps}>
				<ArrowLeft />
			</button>
			<div className={styles.entries}>
				{dateSlots.map((d, i) => (
					<Entry
						slot={d}
						selected={d.date === selected?.date}
						full={filterTimes(d.timesBase).length === 0}
						scroll={scroll}
						onSelect={() => onSelect(i)}
						key={`${d.date}[${d.index}]`}
					/>
				))}
			</div>
			{loading && (
				<div className={styles.spinner}>
					<Spinner />
				</div>
			)}
			<button className={styles.arrow} {...rightProps}>
				<ArrowRight />
			</button>
		</div>
	);
};

export default DateList;
